import { render, staticRenderFns } from "./BasicOnetoOneNew.vue?vue&type=template&id=02222df0&scoped=true"
import script from "./BasicOnetoOneNew.vue?vue&type=script&lang=js"
export * from "./BasicOnetoOneNew.vue?vue&type=script&lang=js"
import style0 from "./BasicOnetoOneNew.vue?vue&type=style&index=0&id=02222df0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02222df0",
  null
  
)

export default component.exports